<template>
<!-- :width="screenWidth" :height="screenHeight" -->
  <div class="act-form">
    <!-- <embed :src="url" id="myID" :width="screenWidth" :height="screenHeight" v-if="is_document">  -->
    <iframe v-if="is_document" :src='url' :width="width" :height="height"></iframe>
    <div v-if="is_img" class="img_wrapper"  :style="'height:'+height+'px;width:'+width+'px'">
        <img  :src="url" :style="'max-width:'+width+'px;max-height:'+height+'px'"/>
    </div>
    <div v-if="is_pdf" id="pdf"  >
      <!-- <iframe  :src='url' type="application/pdf" :width="screenWidth" :height="screenHeight"></iframe> -->
      <!-- <embed :src="url" id="myID" :width="screenWidth" :height="screenHeight"> -->
      <!-- <a :href="url"></a> -->
      <!-- </pdf> -->
      <md-contract :url="url">
      </md-contract>
    </div>
    <div v-if="is_video" >
      <!--<img  :dynsrc="url"  start="mouseover">-->
      <!--<object id="MediaPlayer" classid="clsid:22D6F312-B0F6-11D0-94AB-0080C74C7E95" width="800" height="600" standby="Loading Windows Media Player components…" type="application/x-oleobject" codebase="http://activex.microsoft.com/activex/controls/mplayer/en/nsmp2inf.cab#Version=6,4,7,1112">-->
        <!--<param name="FileName" :value="url">-->
        <!--<param name="AutoStart" value="true">-->
        <!--<param name="ShowControls" value="true">-->
        <!--<param name="BufferingTime" value="2">-->
        <!--<param name="ShowStatusBar" value="true">-->
        <!--<param name="AutoSize" value="true">-->
        <!--<param name="InvokeURLs" value="false">-->
        <!--<param name="AnimationatStart" value="1">-->
        <!--<param name="TransparentatStart" value="1">-->
        <!--<param name="Loop" value="1">-->
        <!--<embed type="application/x-mplayer2" :src="url" name="MediaPlayer" autostart="1" showstatusbar="1" showdisplay="1" showcontrols="1" loop="0" videoborder3d="0" pluginspage="http://www.microsoft.com/Windows/MediaPlayer/" width="800" height="600"></embed>-->
      <!--</object>-->
      <video
      id="myVideo"
      class="video-js">
        <source
        :src="url"
        type="video/mp4">
      </video>

      <!--<embed  align=right   :src="url"  type=application/x-shockwave-flash ></embed >-->
      <!--<video width="235" height="132"  class="material-vedio-body" >-->
        <!--<source :src="url" type="video/mp4" />-->
        <!--<source :src="url" type="video/ogg" />-->
        <!--<source :src="url" type="video/webm" />-->
        <!--<object :data="url" width="235" height="132" align="baseline">-->
          <!--<embed :src="url" width="235" height="132" align="baseline"/>-->
        <!--</object>-->
      <!--</video>-->
    </div>
  </div>

</template>
<script>
// import {PDFObject} from '@/config/pdfobject'
// import header from '../components/pdfobject.vue';
import pdf from 'vue-pdf';

 import mdContract from '../components/contract.md.vue'
  export default {
    components: {pdf},
    data(){
      return {
        tips:'',
        src:'',
        type:'',
        is_document:false,
        is_img:false,
        is_pdf:false,
        is_video:false,
        url:'',
        document_types: ['EXCEL','PPT','WORD'],
        img_types:['图片'],
        pdf:['PDF'],
        video:['MP4']
      }
    },
    props:["height", "width"],
    methods:{
     test(){
         var tvVideo=document.getElementById('myVideo');
         tvVideo.src = this.url;
         console.log(565)
         tvVideo.addEventListener("error", function (e) {
           console.log(123)
         });
      },
      cleartips(){
        this.tips = '';
      },
      initVideo() {
        //初始化视频方法
        let myPlayer = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: "muted",
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: this.width,
          //设置视频播放器的显示高度（以像素为单位）
          height: this.height,
        });
        // this.test();
      }
    },
    mounted() {
      this.url =  this.$route.query.url;
      this.type= this.$route.query.type;
      var that = this;
      // if( this.url.indexOf('doc') > -1 || this.url.indexOf('docx') > -1 || this.url.indexOf('xlsx') > -1 || this.url.indexOf('xls') > -1  || this.url.indexOf('txt') > -1  || this.url.indexOf('pdf') > -1){
      //   this.url = "https://view.officeapps.live.com/op/view.aspx?src=" + this.url;
      //   this.is_document = true;
      // }
      if(this.img_types.indexOf(this.type) > -1){
        this.is_img = true;
      }else if(this.video.indexOf(this.type) > -1){
        this.is_video = true;
        that.$nextTick(function(){
            this.initVideo();
        })
          // if(this.is_video){
              
          // }
      }else if(this.document_types.indexOf(this.type) > -1){
        this.url = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURI(this.url);
        this.is_document = true;
      }else if(this.pdf.indexOf(this.type) > -1){
        // window.onload = function (){
        //   console.log(67)
        //   var id =document.getElementById('pdf');
        // // var success = new PDFObject({ url: this.url}).embed("pdf");
        //   PDFObject.embed(this.url,id);
        // };
        var headers = {
          'Authorization': 'Bearer SOME_TOKEN',
          'x-ipp-device-uuid': 'SOME_UUID',
          'x-ipp-client': 'SOME_ID',
          'x-ipp-client-version': 'SOME_VERSION'
        };

        // this.url = pdf.createLoadingTask({url:this.url, httpHeaders:headers})
        this.is_pdf = true;
      }
    },
     components: {
        mdContract
    }
  }
</script>
<style>
  .img_wrapper {
    /* width: 80%; */
    margin: 0 auto;
    /* height: 90%; */
    text-align: center;
  }
  .img_wrapper img{
    display: block;
    margin: 0 auto;
    /* width: 100%;
    height: auto;
    vertical-align: middle; */
  }
</style>



// WEBPACK FOOTER //
// src/page/preview.vue